<div *ngIf="dashboardSet === null" style="padding: 20px; text-align: center;">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    <p>Loading Dashboard...</p>
</div>

<div *ngIf="dashboardSet === true">
    <div style="margin-bottom: 16px; padding: 10px; display: flex; gap: 16px; align-items: center; background: #f0f2f5; border-radius: 4px;">
        
        <div style="width: 250px;">
            <nz-select 
                [(ngModel)]="selectedAgentId" 
                (ngModelChange)="onFilterChange()"
                nzPlaceHolder="Select an Agent" 
                nzAllowClear
                style="width: 100%;">
                <nz-option *ngFor="let agent of agents" [nzValue]="agent.id" [nzLabel]="getAgentDisplayValue(agent)"></nz-option>
            </nz-select>
        </div>

        <div>
            <nz-range-picker 
                [(ngModel)]="selectedDateRange" 
                (ngModelChange)="onFilterChange()"
                [nzAllowClear]="true">
            </nz-range-picker>
        </div>
    </div>
    <div #dashboardContainer class="dashboard-wrapper" style="height: 80vh; width: 100%;"></div>
</div>

<div *ngIf="dashboardSet === false" class="no-dashboard-message">
    <div style="text-align: center; margin-top: 50px;">
        <span nz-icon nzType="warning" nzTheme="outline" style="font-size: 32px; color: #faad14;"></span>
        <h3 style="margin-top: 16px;">No Home Page Set</h3>
        <p>You have not set a dashboard as your home page yet.</p>
        <a nz-button nzType="primary" routerLink="/analytics-list">Go to Dashboards List</a>
    </div>
</div>